<template>
	<div class="app-main footer-style-one" style="width: 100%">
		<div class="app_container detail_content">
			<div class="course_info">
				<div class="course_info_header">
					<div class="course_info_content">
						<div class="course_nav">
							<div class="el-breadcrumb" aria-label="Breadcrumb" role="navigation">
								<span class="el-breadcrumb__item">
									<span class="el-breadcrumb__inner is-link" role="link">
										<span class="nav_course_title">首页</span>
									</span>
									<i class="el-icon el-breadcrumb__separator">
										<svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
											<path fill="currentColor"
												d="M340.864 149.312a30.592 30.592 0 0 0 0 42.752L652.736 512 340.864 831.872a30.592 30.592 0 0 0 0 42.752 29.12 29.12 0 0 0 41.728 0L714.24 534.336a32 32 0 0 0 0-44.672L382.592 149.376a29.12 29.12 0 0 0-41.728 0z">
											</path>
										</svg>
									</i>
								</span>
								<span class="el-breadcrumb__item">
									<span class="el-breadcrumb__inner is-link" role="link" @click="redirect">
										<span class="nav_course_title">{{isStudy ==1 ?'我的班级':'选课中心'}}</span>
									</span>
									<i class="el-icon el-breadcrumb__separator">
										<svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
											<path fill="currentColor"
												d="M340.864 149.312a30.592 30.592 0 0 0 0 42.752L652.736 512 340.864 831.872a30.592 30.592 0 0 0 0 42.752 29.12 29.12 0 0 0 41.728 0L714.24 534.336a32 32 0 0 0 0-44.672L382.592 149.376a29.12 29.12 0 0 0-41.728 0z">
											</path>
										</svg>
									</i>
								</span>
								<span class="el-breadcrumb__item" aria-current="page">
									<span class="el-breadcrumb__inner" role="link">
										<div class="nav_course_title tx-ov">{{claName}}</div>
									</span>
									<i class="el-icon el-breadcrumb__separator">
										<svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
											<path fill="currentColor"
												d="M340.864 149.312a30.592 30.592 0 0 0 0 42.752L652.736 512 340.864 831.872a30.592 30.592 0 0 0 0 42.752 29.12 29.12 0 0 0 41.728 0L714.24 534.336a32 32 0 0 0 0-44.672L382.592 149.376a29.12 29.12 0 0 0-41.728 0z">
											</path>
										</svg>
									</i>
								</span>
							</div>
						</div>
						<div class="course_message">

							<div class="course_cover">
								<img :src="classOne.imgs_path ? classOne.imgs_path : path " class="course_cover_img">
							</div>

							<div class="course_msg_content">
								<div class="course_price_content">
									<div class="course_name">

										<span>{{claName}}</span>
									</div>
									<div class="course_int">
									</div>
								</div>
								<div class="course_price_info" v-if="isStudy==0 && isBuy ==0">
									<div class="course_price"><span class="course_tip">价格：</span>
										<span class="price_now" style="color: rgb(240, 20, 20);">
											<!----> {{price}}
										</span>
										<!---->

										<span
											style="font-weight: 400;font-size: 14px;color: #999">&nbsp;&nbsp;{{classOne.vip_price == 0? '会员免费' :'' }}</span>
									</div>
								</div>
								<div class="course_cell">
									<span class="course_tip">包含内容：</span>
									<span class="course_cell_item">
										<!--<img src="/_nuxt/class.61ca4301.svg" >-->&nbsp;课程数：{{majorCount}}个
									</span>
									<span class="course_cell_item">
										<!--<img src="/_nuxt/credential.b07686b8.svg" >&nbsp;课程证书：1张-->
									</span>
								</div>
								<div class="course_int">
									<!--<div class="course_int_text tx-ov" >课程作者：供应商培训</div>-->
								</div>
								<!---->
								<div class="course_cell course_cell_valid">
									<span
										class="course_tip">有效期：</span><span>{{classOne.class_start_time}}~{{classOne.class_end_time}}</span>
								</div>
								<!---->
								<div class="course_bottom">
									<div class="course_btn_info">
										<div class="course_btn" v-if="this.isStudy == 0">
											<button class="el-button el-button primary el-button small buy_btn"
												aria-disabled="false" type="button" @click="join" v-if="isBuy == 0">

												<span class="">加入学习</span>
											</button>
											<span v-if="isBuy == 1">已加入学习</span>

										</div>
										<div class="course_learn_msg">
											<span class="learn_item">{{studyCount}}人已学习</span>
											<!--<span class="learn_item icon_btn">
												<span class="icon-collection iconfont"></span><span
													class="icon_text_name">收藏</span>
											</span>
											<span class="learn_item icon_btn">
												<span class="iconfont icon-share"></span>
												<span class="icon_text_name">分享</span>
											</span>-->
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="nav_tabs">
						<div :class=Class @click="tab">班级介绍</div>
						<div :class=Class2 @click="tab2">课程目录</div>
					</div>

				</div>

				<div class="detail_tab_pane note_pane" v-if="!disable">
					<div v-if="classOne.description" class="all_txt" v-html="classOne.description">
					</div>
					<div v-else class="all_txt">
						教务有点懒，还没添加介绍哦
					</div>
					<!-- <div class="all_txt">{{classOne.description ? classOne.description :'教务有点懒，还没添加介绍哦'}}</div> -->
				</div>

				<div class="course" v-if="disable">
					<div class="block_title">全部课程（{{majorCount}}个）</div>
					<ul class="course_list_wrap">

						<li class="course_item" v-for="(i,k) in majorList" :key="k">
							<div class="course_info">
								<span class="course_type">{{i.majorType}}</span>
								<span class="course_name">{{i.majorName}}</span>
							</div>
							<div class="course_handle">
								<!--<span class="course_duration"  style="">01 : 19</span>-->
								<button class="el-button el-button--primary el-button--small is-round learn_btn"
									aria-disabled="false" type="button" v-if="isBuy == 1 && classOne.out == 0 && i.majorType =='在线点播'">
									<span class="" @click="goStudy(i.major_id,i.majorName)"> 开始学习 </span>
								</button>

                <button class="el-button el-button--primary el-button--small is-round learn_btn"
                        aria-disabled="false" type="button" v-if="isBuy == 1 && classOne.out == 0 && i.majorType =='在线练习'">
                  <span class="" @click="goTest(i.major_id,i.majorName)"> 开始练习 </span>
                </button>

                <button class="el-button el-button--primary el-button--small is-round learn_btn"
                        aria-disabled="false" type="button" v-if="isBuy == 1 && classOne.out == 0 && i.majorType =='在线模拟'">
                  <span class="" @click="goMoni(i.major_id,i.majorName)"> 开始模拟 </span>
                </button>

								<button class="el-button el-button--primary el-button--small is-round learn_btn"
									aria-disabled="false" type="button" v-if="i.free_number >0 && isBuy == 0">
									<span class="" @click="goFreeStudy(i.major_id,i.majorName,i.free_number,i.id)"> 免费试听
									</span>
								</button>

							</div>
						</li>

					</ul>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	import {
		getClaDetail,
		joinClass
	} from "../../api/moudles/user";

	import md5 from 'js-md5'

	export default {
		name: "classdetail",

		data() {
			return {

				claName: '',
				claId: '',
				majorList: [],
				path: require('@/assets/img/course.png'),
				classOne: [],
				scId: '',
				Class: 'active nav_tabs_item',
				Class2: 'nav_tabs_item',
				majorCount: '',
				price: '',
				studyCount: '',
				disable: false,
				isBuy: 0,
				isStudy: 0,
			}
		},
		components: {

		},
		created() {

			console.log(this.$route.query.id)

			this.claName = this.$route.query.name
			this.claId = this.$route.query.id

			if (typeof this.$route.query.study != "undefined") { //从我的班级跳转 直接打开课程目录

				this.tab2()

				this.isStudy = 1
			}

			this.fetchData()

		},

		methods: {

			goStudy(major_id, majorName) { //去学习

				if (this.isBuy == 0) {

					this.$message.error("请先加入学习");
					return false
				}


				this.$router.push({
					path: '/videoplay',
					query: {
						major_id: major_id,
						majorName: majorName,
						scId: this.scId
					}
				})

			},

      goTest(major_id, majorName){

        console.log('major_id',major_id)
        console.log('majorName',majorName)

        if (this.isBuy == 0) {
          this.$message.error("请先加入学习");
          return false
        }
        this.$router.push('/myclass?text=class')
        /*this.$router.push({
          path: '/test',
          query: {
            major_id: major_id,
            majorName: majorName,
            scId: this.scId
          }
        })*/

      },

      goMoni(major_id, majorName){
        console.log('major_id',major_id)
        console.log('majorName',majorName)
        if (this.isBuy == 0) {
          this.$message.error("请先加入学习");
          return false
        }
        this.$router.push('/myclass?text=class')
       /* this.$router.push({
          path: '/videoplay',
          query: {
            major_id: major_id,
            majorName: majorName,
            scId: this.scId
          }
        })*/

      },
			goFreeStudy(major_id, majorName, free_number, id) { //免费试听

				let token = localStorage.getItem('userToken')

				let that = this

				if (!token) {
					this.$message.error("请先登录");

					setTimeout(function() {
						that.$bus.$emit('brotherEvent', 'login') //主要解决头部名称和头像不变化的问题
						that.$router.push({
							path: '/login',
							query: {
								redirect: location.hostname
							} //登录完直接跳转详情
						})

					}, 1000)

					return false
				}
				//免费试听
				this.$router.push({
					path: '/videoplayFree',
					query: {
						major_id: major_id,
						majorName: majorName,
						free_number: free_number,
						freeStudy: 1,
						claId: this.claId,
						id: id
					}
				})

			},

			redirect() {

				if (this.isStudy == 1) {
					this.$router.push({
						path: '/userinfo',
						query: {}
					})
				} else {
					this.$router.push({
						path: '/announce/list',
						query: {}
					})
				}

			},


			tab() {

				this.Class2 = 'nav_tabs_item'
				this.Class = 'active nav_tabs_item'
				this.disable = false
			},

			tab2() {
				this.Class2 = 'active nav_tabs_item'
				this.Class = ' nav_tabs_item'
				this.disable = true
			},

			test() {
				window.open('/test')
			},

			join() {

				let token = localStorage.getItem('userToken')

				let that = this

				if (!token) {
					this.$message.error("请先登录");

					setTimeout(function() {
						that.$bus.$emit('brotherEvent', 'login')
						that.$router.push({
							path: '/login',
							query: {
								redirect: location.hostname
							}
						})

					}, 1000)

					return false
				}


				if (this.price == '') {

					this.$message.error("价格未设置，不能加入学习哦");
					return false
				}


				if (this.price != 0) { //目前会员的价格为0

					this.$message.error("您还不是会员哦，请联系企业绑定为企业会员吧");
					return false
				}

				let time = parseInt(new Date().getTime() / 1000)

				joinClass({

					data: {
						id: this.claId,
						userToken: token,
						time: time,
						sign: md5(this.claId + token + time + 'join-class')
					},

					success: (res) => {

						if (res.code != 200) {
							this.$message.error(res.msg);
						} else {
							this.$message.success('加入成功');
							this.isBuy = 1

						}

					}

				})

			},

			fetchData() {


				let token = localStorage.getItem('userToken')

				getClaDetail({

					data: {
						id: this.claId,
						token: token
					},

					success: (res) => {
						this.majorList = res.data.majors

						this.classOne = res.data.clas

						this.majorCount = res.data.majorCount

						this.price = res.data.price
						this.studyCount = res.data.stud_clas_count

						this.isBuy = res.data.isBuy

						if (this.isBuy == 1) { //已购买直接跳到课程目录

							this.tab2()

							this.isStudy = 1
						}


						this.scId = res.data.scId
					}

				})
			}


		}

	}
</script>

<style scoped>
	>>>.all_txt img,
	.all_txt p>img,
	.all_txt p>span>img,
	.all_txt span>img {
		max-width: 100%;
	}

	.footer-style-one.app-main {
		min-height: calc(100vh - 150px);
	}

	.app-main {
		min-height: 100vh;
		background-color: #f6f8fb;
	}

	.detail_content {
		min-height: 100%;
	}

	.app_container {
		padding-bottom: 25px;
	}

	.course_info_content {
		padding: 20px calc((100vw - 1200px)/2);
		background-color: #fff;
		border-top: 1px solid #EBEEF5;
	}

	.course_nav {
		margin-bottom: 20px;
	}

	.el-breadcrumb {
		font-size: 14px;
		line-height: 1;
	}

	.el-breadcrumb__item {
		float: left;
		display: flex;
		align-items: center;
	}

	.el-breadcrumb__inner a,
	.el-breadcrumb__inner.is-link {
		font-weight: 700;
		text-decoration: none;
		transition: var(--el-transition-color);
		color: var(--el-text-color-primary);
	}

	.el-breadcrumb__inner {
		color: var(--el-text-color-regular);
	}

	.nav_course_title {
		color: #becadb;
		font-weight: 400;
		max-width: 115px;
	}

	.el-breadcrumb__separator.el-icon {
		margin: 0 6px;
		font-weight: 400;
	}

	.el-breadcrumb__separator {
		margin: 0 9px;
		font-weight: 700;
		color: var(--el-text-color-placeholder);
	}

	.el-icon {
		--color: inherit;
		height: 1em;
		width: 1em;
		line-height: 1em;
		display: inline-flex;
		justify-content: center;
		align-items: center;
		position: relative;
		fill: currentColor;
		color: var(--color);
		font-size: inherit;
	}

	.el-breadcrumb__separator.el-icon svg {
		vertical-align: middle;
	}

	.el-icon svg {
		height: 1em;
		width: 1em;
	}

	.el-breadcrumb__item {
		float: left;
		display: flex;
		align-items: center;
	}

	.el-breadcrumb__inner a,
	.el-breadcrumb__inner.is-link {
		font-weight: 700;
		text-decoration: none;
		transition: var(--el-transition-color);
		color: var(--el-text-color-primary);
	}

	.el-breadcrumb__inner {
		color: var(--el-text-color-regular);
	}


	.el-breadcrumb__separator {
		margin: 0 9px;
		font-weight: 700;
		color: var(--el-text-color-placeholder);
	}

	.el-breadcrumb__separator.el-icon svg {
		vertical-align: middle;
	}

	.el-icon svg {
		height: 1em;
		width: 1em;
	}

	.el-breadcrumb__item {
		float: left;
		display: flex;
		align-items: center;
	}

	.el-breadcrumb__inner a,
	.el-breadcrumb__inner.is-link {
		font-weight: 700;
		text-decoration: none;
		transition: var(--el-transition-color);
		color: var(--el-text-color-primary);
	}

	.nav_course_title {
		color: #becadb;
		font-weight: 400;
		max-width: 115px;
	}

	.el-breadcrumb__separator.el-icon {
		margin: 0 6px;
		font-weight: 400;
	}

	.el-breadcrumb__separator {
		margin: 0 9px;
		font-weight: 700;
		color: var(--el-text-color-placeholder);
	}

	.el-breadcrumb__separator.el-icon svg {
		vertical-align: middle;
	}

	.el-icon svg {
		height: 1em;
		width: 1em;
	}

	.el-breadcrumb__item {
		float: left;
		display: flex;
		align-items: center;
	}

	.el-breadcrumb__item:last-child .el-breadcrumb__inner,
	.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
	.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
	.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
		font-weight: 400;
		color: var(--el-text-color-regular);
		cursor: text;
	}

	.nav_course_title {
		color: #becadb;
		font-weight: 400;
		max-width: 115px;
	}

	.tx-ov {
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}

	.el-breadcrumb__item:last-child .el-breadcrumb__separator {
		display: none;
	}

	.el-breadcrumb__separator.el-icon {
		margin: 0 6px;
		font-weight: 400;
	}

	.el-breadcrumb__separator {
		margin: 0 9px;
		font-weight: 700;
		color: var(--el-text-color-placeholder);
	}


	.el-breadcrumb__separator.el-icon svg {
		vertical-align: middle;
	}

	.el-icon svg {
		height: 1em;
		width: 1em;
	}

	.course_message {
		display: flex;
		position: relative;
	}

	.course_cover {
		position: relative;
	}

	.course_cover_img {
		width: 567px;
		height: 340px;
		-o-object-fit: cover;
		object-fit: cover;
		border-radius: 5px;
	}

	img,
	video {
		max-width: 100%;
		height: auto;
	}

	img,
	canvas,
	iframe,
	video {
		display: block;
		vertical-align: middle;
	}


	.course_msg_content {
		width: 598px;
		margin-left: 30px;
		position: relative;
	}

	.course_price_content {
		width: 100%;
	}

	.course_name {
		font-style: normal;
		font-weight: 400;
		font-size: 20px;
		color: #333;
	}

	.course_name_tag {
		padding: 5px 3px;
		border-radius: 5px 0;
		background: rgba(61, 127, 255, .1);
		display: inline-block;
		font-style: normal;
		width: 46px;
		position: relative;
		top: -2px;
		text-align: center;
		font-weight: 400;
		font-size: 10px;
		color: #3d7fff;
		margin-right: 4px;
	}

	.course_int {
		margin-top: 5px;
		display: flex;
	}

	.course_int .course_int_text {
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #999;
		width: 570px;
	}

	.tx-ov {
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}

	.course_price_info {
		margin-top: 10px;
		margin-bottom: 12px;
		background: #F5F5F5;
		padding: 13px 10px 17px;
	}

	.course_price_info .course_tip {
		letter-spacing: .6em;
	}

	.course_tip {
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #999;
	}

	.price_now {
		font-style: normal;
		font-weight: 700;
		font-size: 26px;
		color: #f01414;
	}

	.course_cell {
		overflow: hidden;
		width: 100%;
		display: flex;
		align-items: center;
	}


	.course_cell .course_cell_item {
		white-space: nowrap;
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #333;
		display: flex;
		align-items: center;
	}

	.course_cell_item {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		word-break: break-all;
		overflow: auto;
	}

	img,
	video {
		max-width: 100%;
		height: auto;
	}

	img,
	canvas,
	iframe,
	video {
		display: block;
		vertical-align: middle;
	}

	.course_cell .course_cell_item+.course_cell_item {
		padding-left: 24px;
		position: relative;
	}

	.course_cell .course_cell_item {
		white-space: nowrap;
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #333;
		display: flex;
		align-items: center;
	}

	.course_cell_item {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		word-break: break-all;
		overflow: auto;
	}

	img,
	video {
		max-width: 100%;
		height: auto;
	}

	img,
	canvas,
	iframe,
	video {
		display: block;
		vertical-align: middle;
	}

	/*img {
  border-style: solid;
}*/

	.course_int {
		margin-top: 5px;
		display: flex;
	}

	.course_int .course_int_text {
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #999;
		width: 570px;
	}

	.tx-ov {
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}

	.course_cell_valid {
		margin-top: 5px;
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
	}

	.course_cell {
		overflow: hidden;
		width: 100%;
		display: flex;
		align-items: center;
	}

	.course_cell_valid .course_tip {
		letter-spacing: .32em;
	}

	.course_tip {
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #999;
	}

	.course_bottom {
		margin-top: 29px;
		width: 100%;
	}

	.course_btn_info {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 5px;
	}

	.buy_btn {
		width: 154px;
		height: 40px;
		font-size: 16px;
	}


	.course_learn_msg {
		display: flex;
		align-items: center;
	}

	.learn_item {
		position: relative;
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #999;
	}

	.learn_item+.learn_item {
		padding-left: 20px;
	}

	.icon_btn {
		cursor: pointer;
	}

	.learn_item {
		position: relative;
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #999;
	}

	.iconfont {
		cursor: pointer;
	}

	.iconfont {
		font-family: iconfont !important;
		font-size: 16px;
		font-style: normal;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	.icon_text_name {
		margin-left: 3px;
	}

	.learn_item+.learn_item {
		padding-left: 20px;
	}

	.icon_btn {
		cursor: pointer;
	}

	.learn_item {
		position: relative;
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #999;
	}

	.iconfont {
		cursor: pointer;
	}

	.iconfont {
		font-family: iconfont !important;
		font-size: 16px;
		font-style: normal;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	.icon_text_name {
		margin-left: 3px;
	}

	.nav_tabs {
		padding: 20px calc((100vw - 1200px)/2) 0;
		background-color: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.nav_tabs .nav_tabs_item.active,
	.nav_tabs .nav_tabs_item:hover {
		color: #2256f6;
	}

	.nav_tabs .nav_tabs_item {
		margin-right: 60px;
		font-style: normal;
		font-weight: 400;
		font-size: 16px;
		padding-bottom: 20px;
		color: #333;
		position: relative;
		cursor: pointer;
	}

	.nav_tabs .nav_tabs_item:last-child {
		margin-right: 0;
	}


	.nav_tabs .nav_tabs_item {
		margin-right: 60px;
		font-style: normal;
		font-weight: 400;
		font-size: 16px;
		padding-bottom: 20px;
		color: #333;
		position: relative;
		cursor: pointer;
	}

	.detail_tab_pane {
		padding: 30px;
		background-color: #fff;
		border-radius: 5px;

		margin: 10px auto auto;
		padding: 30px 350px;
	}


	.detail_desc_content {
		line-height: 32px;
	}

	.course {
		margin-top: 10px;
		background: #ffffff;
		border-radius: 5px;
		padding: 30px 350px;
	}

	.block_title {
		font-size: 18px;
	}

	.course_list_wrap {
		margin-top: 36px;
	}

	ul,
	li {
		margin: 0;
		padding: 0;
		list-style: none;
	}

	.course_item {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 20px;
		background-color: #fff;
		color: #333;
	}

	.course_item .course_type {
		color: #999;
		border: 1px solid #999999;
		border-radius: 2px;
		font-size: 12px;
		line-height: 20px;
		padding: 2px 5px;
	}

	.course_item .course_name {
		margin-left: 10px;
		font-size: 14px;
		line-height: 18px;
	}

	.course_item .course_duration {
		font-size: 14px;
		line-height: 18px;
		color: #999;
	}

	.course_item .learn_btn {
		position: absolute;
		top: 20px;
		right: 20px;
	}

	.el-button--small.is-round {
		padding: 5px 11px;

	}

	.el-button.is-round {
		border-radius: var(--el-border-radius-round);
	}

	.el-button.is-round {
		padding: 6px 15px;
	}

	button,
	[type=button],
	[type=reset],
	[type=submit] {
		-webkit-appearance: button;
	}

	.el-button--small {
		--el-button-size: 24px;
		height: var(--el-button-size);
		padding: 5px 11px;
		font-size: 12px;

		border-radius: calc(var(--el-border-radius-base) - 1px);
	}

	.el-button>span {
		display: inline-flex;
		align-items: center;
	}
</style>
